export class ErrorToSend {
    public constructor(public errorId:String, public name:String, 
        public msg:String, public stack:String, public playerId:String) 
    {
    }
}